

class List{
    defaultOptions() {
        return {
        	'$container': null,
        	'onClickNext': function(){},
        	'urlDetail': '/club/detail'
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        this.response = null;
        this.data = this.settings.data;
        this.needClear = true;

        this.initialize();
    }


    setNeedClear(value){
    	this.needClear = value;
    }

    initialize(){

    }

    goToFirstResult(){

    	let $firstItem = $('.club-list-item',this.$container).first();
    	setTimeout(
    		function(){
    			window.scrollToElement($firstItem);
    		},
    		300
    	);
    }

    setData(xhr){
    	this.response = xhr;
    	this.data = xhr.data;
    	this.build();
    }

    build(){
    	if(this.needClear){
	        this.$container
	        .html('');
			this.$list = $('<ul/>')
			.addClass('club-list')
			.appendTo(this.$container);
	    }else{
	    	this.removeNextButton();
	    }

		for(var i in this.data){
			let item = this.data[i];

			let $item = this.buildItem(item);

			this.$list.append($item);
		}

		if(this.response.hasNext){
			let $next = this.buildNextButton();
			this.$list.append($next);
		}
    }

    buildItem(item){
    	let $item = $('<li/>')
		.addClass('club-list-item');


		let city = item.VilleOrga;
		let name = item.NomCompletOrga;
		let typeLabel = item.typeAssoLabel;
        let url = this.settings.urlDetail + '?id='+item.Id;
		let website = item.SiteOrga;
		if(!window.isUrl(website)){
			website = url;
		}
        let tel = item.TelContactOrga;
        if(!tel){
        	tel = item.TelOrga;
        }
        let activites = '';
        for(var i in item.activites){
        	let activite = item.activites[i];
        	let label = activite.name;

        	let icon = '<i class="icon icon-activite-'+activite.slug+'" title="'+label+'"></i>';

        	activites += ' ' + icon;
        }

        let $logo = $('<i/>').addClass('icon icon-club icon-2x');
        if(item.logo && false){//remove && false to enable display of organisme.logo
        	$logo = $('<div/>')
        	.addClass('club-logo-wrapper')
        	.append(
	        	$('<img/>')
	        	.attr('src',item.logo)
	        	.addClass('club-logo')
	        );
        }

		$item
		.addClass('club row')
		.append(
			$('<div/>')
			.addClass('col-lg-5 col-12')
			.append(
				$('<div/>')
				.addClass('club-safe club-search-list__item')
				.append(
					$('<div/>')
					.addClass('club-search-list__item__wrapper')
					.append(
						$logo
					)
					.append(
						$('<div/>')
						.addClass('club-number-label label')
						.append(name)
					)
					.append(
						$('<div/>')
						.addClass('club-number-value')
						.append(city)
					)
					.append(
						$('<small/>')
						.addClass('club-number-value')
						.append(typeLabel)
					)
				)
			)
		)
		.append(
			$('<div/>')
			.addClass('col-lg-2 col-12')
			.append(
				$('<div/>')
				.addClass('club-activite club-search-list__item')
				.append(
					$('<div/>')
					.addClass('club-search-list__item__wrapper')
					.append(activites)
				)
			)
		)
		.append(
			$('<div/>')
			.addClass('col-lg-1 col-12')
			.append(
				$('<div/>')
				.addClass('club-website club-search-list__item')
				.append(
					$('<div/>')
					.addClass('club-search-list__item__wrapper')
					.append(
						$('<a/>')
						.attr('target','_blank')
						.attr('href',website)
						.addClass('btn btn-text')
						.attr('title', website)
						.append(
							$('<i/>')
							.addClass('icon icon-website')
						)
					)
				)
			)
		)
		.append(
			$('<div/>')
			.addClass('col-lg-1 col-12')
			.append(
				$('<div/>')
				.addClass('club-phone club-search-list__item')
				.append(
					$('<div/>')
					.addClass('club-search-list__item__wrapper')
					.append(
						$('<a/>')
						.attr('href','tel:'+tel)
						.attr('title',tel)
						.addClass('btn btn-text')
						.append(
							$('<i/>')
							.addClass('icon icon-phone-circle')
						)
					)
				)
			)
		)
		.append(
			$('<div/>')
			.addClass('col-lg-3 col-12')
			.append(
				$('<div/>')
				.addClass('club-detail club-search-list__item')
				.append(
					$('<a/>')
					.attr('href',url)
					.addClass('btn btn-text btn-icon')
					.append('En savoir plus')
					.append(
						$('<i/>')
						.addClass('icon icon-plus')
					)
				)
			)
		);

		return $item;
    }

    removeNextButton(){
    	$('.club-list-item-btn',this.$list).remove();
    }

    buildNextButton(){
    	var self = this;
    	let $item = $('<li/>')
		.addClass('club-list-item club-list-item-btn');

		let $btnNext = $('<button/>')
		.addClass('btn btn-primary btn-next')
		.attr('data-value',this.response.next)
		.append("Voir plus ("+this.response.remains+')')
		.on('click',function(){
			let $btn = $(this);
			$btn.attr('disabled','disabled');
			$btn.html('')
			.append(
				$('<i/>')
				.addClass('fa fa-spin fa-spinner')
			)
			self.settings.onClickNext($btn.data('value'))
		});

		$item.append($btnNext);

		return $item;

    }
}

module.exports = List;